import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UpdateView } from '../pages/school/global/update-view/update-view';
import { CreateView } from '../pages/school/global/create-view/create-view';
import { LoginLogout } from '../view-logs-components/login-logout/login-logout';

@Component({
  selector: 'app-logs-view',
  standalone: true,
  imports: [UpdateView, CreateView, LoginLogout], // Add UpdateView and CreateView here
  templateUrl: './logs-view.html',
  styleUrls: ['./logs-view.scss'],
})
export class LogsView implements OnInit {
  logId: string | null = null;
  logAction: string | null = null;
  logData: any = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.logId = params['id'];
      this.logAction = params['action'];
    });

    this.logData = history.state.logData || null;
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }


}

